import { WidgetTableColumn, WidgetTableColumnsData } from 'jamespot-user-api';

export const getVisibleColumns = (tableColumnsData: WidgetTableColumnsData, columns: WidgetTableColumn[]) => {
    const toRet: WidgetTableColumn[] = [];
    tableColumnsData
        .filter((data) => data.isVisible)
        .forEach((data) => {
            const column = columns.find((el) => el.name === data.name);
            if (column) {
                toRet.push(column);
            }
        });

    return toRet;
};
